import I18n from "i18n-js";
import { makeAutoObservable, runInAction } from "mobx";
import { toPairs } from "../../core";
import { ErrorBox, TextFieldController } from "../../form";
export class StreetAddressFormController {
    constructor(params) {
        this.streetAddress = params.streetAddress;
        this.geocodingService = params.geocodingService;
        this.geolocationService = params.geolocationService;
        this.street = new TextFieldController({
            initialValue: this.streetAddress.street,
            onUpdate: (str) => {
                this.streetAddress.street = str;
                params.onChange && params.onChange();
            },
            errorBox: new ErrorBox({
                domainObjects: [this.streetAddress],
                errorMessages: {
                    StreetMissing: I18n.t("_common.form.errors.required"),
                },
            }),
        });
        this.streetNumber = new TextFieldController({
            initialValue: this.streetAddress.streetNumber,
            onUpdate: (str) => {
                this.streetAddress.streetNumber = str;
                params.onChange && params.onChange();
            },
            errorBox: new ErrorBox({
                domainObjects: [this.streetAddress],
                errorMessages: {
                    StreetNumberMissing: I18n.t("_common.form.errors.required"),
                },
            }),
        });
        this.city = new TextFieldController({
            initialValue: this.streetAddress.city,
            onUpdate: (str) => {
                this.streetAddress.city = str;
                params.onChange && params.onChange();
            },
            errorBox: new ErrorBox({
                domainObjects: [this.streetAddress],
                errorMessages: {
                    CityMissing: I18n.t("_common.form.errors.required"),
                },
            }),
        });
        this.postCode = new TextFieldController({
            initialValue: this.streetAddress.postCode,
            onUpdate: (str) => {
                this.streetAddress.postCode = str;
                params.onChange && params.onChange();
            },
            errorBox: new ErrorBox({
                domainObjects: [this.streetAddress],
                errorMessages: {
                    PostCodeMissing: I18n.t("_common.form.errors.required"),
                },
            }),
        });
        if (!this.streetAddress.isEmpty) {
            this.submit();
        }
        makeAutoObservable(this);
    }
    get fields() {
        return {
            street: this.street,
            streetNumber: this.streetNumber,
            city: this.city,
            postCode: this.postCode,
        };
    }
    get fieldsArray() {
        return toPairs(this.fields).map(([_, field]) => field);
    }
    get isDirty() {
        return this.fieldsArray.some((field) => field.isDirty);
    }
    get isTouched() {
        return this.fieldsArray.some((field) => field.isTouched);
    }
    get isInvalid() {
        const fieldsInvalid = this.fieldsArray.some((field) => field.isInvalid);
        const modelInvalid = this.streetAddress.availability.isAvailable.isDefinitelyFalse;
        return fieldsInvalid || modelInvalid;
    }
    get isValid() {
        return !this.isInvalid;
    }
    get domain() {
        return this.streetAddress;
    }
    submit() {
        this.fieldsArray.forEach((field) => field.blur());
    }
    // TODO: move this method from the controller to the domain
    async locateMe() {
        const { latitude: lat, longitude: lon } = await this.geolocationService.getCurrentPosition();
        const streetAddress = await this.geocodingService.reverseGeocode(null, {
            lat,
            lon,
        });
        runInAction(() => {
            if (streetAddress) {
                this.fields.city.change(streetAddress.city);
                this.fields.street.change(streetAddress.street);
                this.fields.streetNumber.change(streetAddress.streetNumber);
                this.submit();
            }
        });
        return streetAddress !== null;
    }
}
